var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Can', {
    attrs: {
      "I": _vm.ActionEnum.READ,
      "a": _vm.ResourceEnum.TAG,
      "field": _vm.value.partnerId
    }
  }, [_c('select-tags', {
    attrs: {
      "resource": _vm.resource,
      "partnerId": _vm.value.partnerId,
      "loading": _vm.loading,
      "disabled": false,
      "readonly": false
    },
    on: {
      "input": function input(tags) {
        _vm.loading = true;

        _vm.debounceOnTagsChanged(tags);
      }
    },
    model: {
      value: _vm.value.tags,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "tags", $$v);
      },
      expression: "value.tags"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }